/** Coins (docs/game-design.md §11). Placeholders until the M7 shop. */
export const ECONOMY = {
  coins: {
    win: 50,
    koWin: 75,
    draw: 25,
    loss: 10,
  },
  /** First reset each league season is free; after that it costs this. */
  skillResetCost: 500,
} as const;
